var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3107_3219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 29.3332C8.6373 29.3332 2.66797 23.3638 2.66797 15.9998C2.66797 8.63584 8.6373 2.6665 16.0013 2.6665C23.3653 2.6665 29.3346 8.63584 29.3346 15.9998C29.3346 23.3638 23.3653 29.3332 16.0013 29.3332ZM16.0013 26.6665C18.8303 26.6665 21.5434 25.5427 23.5438 23.5423C25.5442 21.5419 26.668 18.8288 26.668 15.9998C26.668 13.1709 25.5442 10.4578 23.5438 8.45736C21.5434 6.45698 18.8303 5.33317 16.0013 5.33317C13.1723 5.33317 10.4592 6.45698 8.45883 8.45736C6.45844 10.4578 5.33464 13.1709 5.33464 15.9998C5.33464 18.8288 6.45844 21.5419 8.45883 23.5423C10.4592 25.5427 13.1723 26.6665 16.0013 26.6665ZM17.3346 15.9998H22.668V18.6665H14.668V9.33317H17.3346V15.9998Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3107_3219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timerIcon.97542f597cba9d02ac9f46f481821f3d.svg";
export { ForwardRef as ReactComponent };